<template>
    <a-drawer
        :width="drawerWidth"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="close"
    >
        <template slot="title">
            <slot name="title">
                <i class="fa-solid fa-filter"></i>
                Filtros Avançados
            </slot>
        </template>

        <a-form layout="vertical" hide-required-mark>
            <slot />
        </a-form>

        <div class="drawer-footer">
            <slot name="footer">
                <a-button
                    type="primary"
                    class="btn-apply"
                    @click="apply"
                >
                    <i class="fa-solid fa-magnifying-glass"></i>
                    Filtrar
                </a-button>

                <a-button
                    type="danger"
                    class="btn-clear"
                    @click="$emit('clear')"
                >
                    <i class="fa-solid fa-filter-circle-xmark"></i>
                    Limpar Filtros
                </a-button>

                <a-button
                    class="btn-close"
                    @click="close"
                >
                    Fechar
                </a-button>
            </slot>
        </div>
    </a-drawer>
</template>
<script>
export default {
  name: 'AdvancedFiltersDrawer',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    width: {
      type: Number,
      default: 720
    }
  },

  data() {
    return {
      screenWidth: window.innerWidth
    };
  },

  computed: {
    drawerWidth() {
      return this.screenWidth < this.width
        ? this.screenWidth
        : this.width;
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    apply() {
        this.$emit('apply');
        this.close();
    },
    close() {
        this.$emit('update:visible', false);
    }
  }
};
</script>
<style lang="css" scoped>
.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: left;
  z-index: 1;
}

.drawer-footer .btn-apply {
  padding: 0 30px;
}

.drawer-footer .btn-clear,
.drawer-footer .btn-close {
  margin-left: 8px;
}

.drawer-footer .btn-clear {
  padding: 0 10px;
}
</style>